/**
 * create by zpf 2018-08-07
 * 所有action的基类
 */
import React from 'react'
import contextModel from '../model/contextModel'
import config from '../model/configModel'
import eventFactory from './eventFactory'
import JsonModel from '../store/JsonModel'
import { DateUtil, NewKeyUtil } from 'wbap-utils'

class actionBase {
  constructor (appInfo) {
    //存放单据状态
    this.unitState = {}
    this.unitKind_Map = new Map()
    this.actionSQLItem = appInfo.action
    this.model = new JsonModel()//model对象
    this.actQuery = new eventFactory(this.model)//查询按钮
    this.actInsert = new eventFactory(this.model)  //新增
    this.actEdit = new eventFactory(this.model)//编辑
    this.actSave = new eventFactory(this.model)//保存
    this.actCancel = new eventFactory(this.model)//取消
    //扩展功能
    this.buttonExtend = []
    //-----------------------------//
    this.initialize()
  }

  /**
   * 初始化配置信息
   */
  initialize () {
    this.initEvent()
    this.initSQLItem()
    this.initParameters()
  }

  /**
   *
   * @private
   */
  _test () {}

  /**
   * 初始化配置信息(按钮事件)
   */
  initEvent () {
    //------------查询------------------//
    this.actQuery.onBeforeExecute = (target) => {
      this.actQuery_onBeforeExecute(target)
    }
    this.actQuery.onExecuting = (target) => {
      this.actQuery_onExecuting(target)
    }
    this.actQuery.onAfterExecute = (target) => {
      this.actQuery_onAfterExecute(target)
    }
    //------------新增------------------//
    this.actInsert.onBeforeExecute = (target) => {
      this.actInsert_onBeforeExecute(target)
    }
    this.actInsert.onExecuting = (target) => {
      this.actInsert_onExecuting(target)
    }
    this.actInsert.onAfterExecute = (target) => {
      this.actInsert_onAfterExecute(target)
    }
    //------------修改------------------//
    this.actEdit.onBeforeExecute = (target) => {
      this.actEdit_onBeforeExecute(target)
    }
    this.actEdit.onExecuting = (target) => {
      this.actEdit_onExecuting(target)
    }
    this.actEdit.onAfterExecute = (target) => {
      this.actEdit_onAfterExecute(target)
    }
    //------------保存------------------//
    this.actSave.onBeforeExecute = (target) => {
      this.actSave_onBeforeExecute(target)
    }
    this.actSave.onExecuting = (target) => {
      this.actSave_onExecuting(target)
    }
    this.actSave.onAfterExecute = (target) => {
      this.actSave_onAfterExecute(target)
    }
    //------------取消------------------//
    this.actCancel.onBeforeExecute = (target) => {
      this.actCancel_onBeforeExecute(target)
    }
    this.actCancel.onExecuting = (target) => {
      this.actCancel_onExecuting(target)
    }
    this.actCancel.onAfterExecute = (target) => {
      this.actCancel_onAfterExecute(target)
    }
  }

  /**
   * 构造SQLItem
   * 默认读取constant/ActionSQLItem.js文件中定义的
   */
  initSQLItem () {
    if (!this.actionSQLItem) return
    for (let key in this.actionSQLItem) {
      if (!this[key]) continue
      this[key].sqlItems = this.actionSQLItem[key]
      //处理enabled=true的,防止自动触发
      let _filter = this[key].sqlItems.filter(_item => _item.enabled)
      if (_filter && _filter.length > 0) {
        _filter.map(_item => {
          if (_item['enabled'])
            _item['enabled'] = false
        })
      }
    }
  }

  /**
   * 过滤可见状态
   * @returns {Array.<*>}
   */
  getButtonByVisibleState (_state) {
    let _arrButton = []
    for (let _button of this.buttonExtend) {
      if (!_button.visibleState) {
        _arrButton.push(_button)
        continue
      }
      //可见状态
      let _arr_visibleState = _button.visibleState.split(',')
      if (_arr_visibleState.includes(_state)) {
        _arrButton.push(_button)
      }
    }
    return _arrButton
  }

  /**
   * 其他参数设置
   */
  initParameters () {
    this.getUnitState()
    this.getUnitKind()
  }

  /**
   * 取单据状态
   */
  getUnitState () {

  }

  /**
   * 取业务类型
   */
  getUnitKind () {
  }

  /**
   * 查询
   * @param target
   * @returns {Promise.<void>}
   */
  actQuery_onBeforeExecute (target) {
    this.paramsFormat(target)
  }

  actQuery_onExecuting (target) {

  }

  actQuery_onAfterExecute (target) {

  }

  /**
   * 新增
   * @param target
   */
  actInsert_onBeforeExecute (target) {

  }

  actInsert_onExecuting (target) {

  }

  actInsert_onAfterExecute (target) {

  }

  /**
   * 修改
   */
  actEdit_onBeforeExecute (target) {
    this.paramsFormat(target)
  }

  actEdit_onExecuting (target) {

  }

  actEdit_onAfterExecute (target) {

  }

  /**
   * 保存
   */
  actSave_onBeforeExecute (target) {
    this.paramsFormat(target)
  }

  actSave_onExecuting (target) {

  }

  actSave_onAfterExecute (target) {
  }

  /**
   * 取消
   */
  actCancel_onBeforeExecute (target) {

  }

  actCancel_onExecuting (target) {

  }

  actCancel_onAfterExecute (target) {
  }

  /**
   * 自定义事件
   */
  event_onBeforeExecute (target) {
    this.paramsFormat(target)
  }

  /**
   * 执行后验证日志是否有报错
   * @param target
   */
  event_onAfterExecute (target) {
    if (!target.executed) return
    let _result = this.validateNotes()
    target.executed = _result
  }

  /**
   * 通过日志判断操作结果
   * @returns {boolean}
   */
  validateNotes () {
    let _notes = this.model.tableJson(this.note_sid)
    if (_notes && _notes.length > 0) {
      // Toast.show(_notes[0].FREMARK)
      // return ConvertUtil.toBoolean(_notes[0].FRESULT)
    }
    return true
  }

  /**
   * 构造查询和执行条件
   * @param target
   */
  paramsFormat (target) {
    let mid = this.ma_mid, tid = ''
    //------------------查询条件------------------------//
    // target.selectParam.clear()
    target.selectParam.set('FMID', mid)
    target.selectParam.set('FPID', mid)
    target.selectParam.set('FTID', tid)
    target.selectParam.set('FUID', '')
    //BAP后台固定这个值
    target.selectParam.set('FOID', '{7D77D027-9824-4156-A25E-12FC59527DDE}')
    //FWID终端站点唯一标识
    target.selectParam.set('FWID', '')
    //当前库存地点
    target.selectParam.set('FORG_STORE_ID', '')
    //查询列表时需要传入单据名称
    target.selectParam.set('FUNIT_NAME', this.unit_Name)
    //动态的where条件
    this.queryCondition(target)

    //------------------执行条件------------------------//
    //Modify by liupeng on 2018-03-01
    target.executeParam.splice(0, target.executeParam.length)  //清空
    let _param = {}
    _param['FMID'] = mid
    _param['FTID'] = tid
    _param['FUNIT_ID'] = ''
    _param['FUNIT_NAME'] = ''
    _param['FACTION_ID'] = ''
    _param['FACTION_NAME'] = ''
    _param['FUID'] = ''
    _param['FOPERATORID'] = ''
    _param['FOPERATOR'] = ''
    target.executeParam.push(_param)
  }

  /**
   * sql语句中的where条件
   * @param target
   */
  queryCondition (target) {

  }

  get ma_mid () {
    return NewKeyUtil.newGuid()
  }

  get note_sid () {
    return '{E1A86C78-C808-4D77-9E78-F05AAD412FC5}'
  }

  /**
   * 显示吐司
   * @param args
   */
  toast (...args) {
    const Toast = config.getToast()
    if (!Toast || args.length === 0 || !Toast[args[0]]) return
    Toast[args[0]](...args.slice(1))
  }

  /**
   * 显示通知
   * @param args
   */
  notification (...args) {
    const Notification = config.getNotification()
    if (!Notification || args.length === 0 || !Notification[args[0]]) return
    Notification[args[0]](...args.slice(1))
  }

  /**
   * 显示模态框
   * @param args
   * @return {*}
   */
  modal (...args) {
    const Modal = config.getModal()
    if (!Modal || args.length === 0 || !Modal[args[0]]) return
    return Modal[args[0]](...args.slice(1))
  }

  /**
   * 获取上下文
   * @return {contextModel}
   */
  getContext () {
    return contextModel
  }

}

export default actionBase


// WEBPACK FOOTER //
// ./src/wbap-core-commit/commit/actionBase.js